import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Components',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
